module.exports = __webpack_public_path__ + "static/media/noun-checkmark-3345771-0DC25E.5969def0.svg";